export default __webpack_public_path__ + "static/media/205.f2e06077.jpg";